import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { moveToChangeSubscription } from 'actions/billing/subscription_modal'

// raw function used in Redux Actions
export const upgradeSubscription = ({
  dispatch,
  featureKey,
  skipPreface,
  onSuccess,
  paywallOverride,
  minQuantity,
  invitationsQuantity
}) => {
  dispatch(moveToChangeSubscription({
    featureKey,
    preface: !skipPreface,
    onSuccess,
    paywallOverride,
    minQuantity,
    invitationsQuantity
  }))
}

export const useUpgradeSubscription = ({
  featureKey,
  skipPreface,
  paywall,
  type,
  noTracking,
  paywallOverride
} = { skipPreface: false }) => {
  const dispatch = useDispatch()

  return useCallback(
    () => upgradeSubscription({
      dispatch,
      featureKey,
      skipPreface,
      paywall,
      type,
      noTracking,
      paywallOverride
    }), [
      dispatch,
      featureKey,
      skipPreface,
      paywall,
      type,
      noTracking,
      paywallOverride
    ]
  )
}
